module.exports = __webpack_public_path__ + "static/img/select-img8.3a438a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/select-img8.png
// module id = QQM9
// module chunks = 1